<template>
  <div>
    <div class="ticket_info_user_title ticket_icon">
      <div class="way_title_left">
        <img :src="staticAssets.ImgObj.view_people" alt />
        <span>{{TLang('观演人','my')}}</span>
        <i class="people_amount">（ {{ `${ReplaceText("X",mul_totalCount,TLang("共需X位观演人",'my',false,false,null),false)}` }} ）</i>
      </div>
      <el-popover
        placement="left"
        width="146"
        height="32"
        trigger="manual"
        popper-class="qr_code_add"
        v-model="tips_model"
      >
        <span>
          <img :src="staticAssets.ImgObj.tips_icon" alt />
          {{TLang('请添加观演人信息','my')}}
        </span>
        <a
          href="javascript:;"
          class="ticket_info_user_add"
          :class="
            cardTableData.length >= mul_totalCount
              ? 'ticket_info_user_add_disabled'
              : ''
          "
          slot="reference"
          @click="ticketUserAdd"
        >
          <img
            :src="
              cardTableData.length >= mul_totalCount
                ? staticAssets.ImgObj.user_add_disabled
                : staticAssets.ImgObj.user_add
            "
            alt
          />
          {{TLang('添加','my')}}
        </a>
      </el-popover>
    </div>
    <div class="ticket_info_user_table">
      <div class="ticket_info_empty" v-if="this.cardTableData.length < 1">
        {{TLang('暂无观演人信息','my')}}
      </div>
      <div
        v-for="(card_item, cIndex) in cardTableData"
        :key="`card${cIndex}`"
        class="ticket_info_user_item"
        :class="{
          active_background: operate_flag == parseInt(cIndex + 1)
        }"
        @mouseover="getMouseEnter(cIndex)"
        @mouseleave="getMouseOut(cIndex)"
      >
        <div class="info_left">
          <span class="user_item_no">{{ cIndex + 1 }}</span>
          <el-popover
            placement="bottom-start"
            width="220"
            style="display:flex"
            trigger="hover"
            popper-class="qr_code_card"
          >
            <a href="javascript:;" class="user_itm_name" slot="reference">{{
              card_item.ownerName
            }}</a>
            <span class="user_itm_name">{{ card_item.ownerName }}</span>
          </el-popover>

          <span class="user_item_line_id"></span>
          <span class="user_item_card user_item_tel">
            {{ publicMethod.getExchangeCard(card_item.ownerIdCardNo) }}
          </span>
          <span class="user_item_tel_nomal">{{
            publicMethod.getExchangeTel(card_item.ownerPhone)
          }}</span>

          <span style="margin-left:24px;">{{TLang('无座','my')}}</span>
        </div>
        <div class="operate_right" v-if="operate_flag == parseInt(cIndex + 1)">
          <a
            href="javascript:;"
            class="edit_left"
            :class="{
              active_edit: active_edit_flag == parseInt(cIndex + 1)
            }"
            @mouseover="editMouseEnter(cIndex)"
            @mouseleave="editMouseOut(cIndex)"
            @click.prevent.stop="editUserInfo(cIndex)"
          >
            <img
              :src="
                active_edit_flag == parseInt(cIndex + 1)
                  ? staticAssets.ImgObj.select_edit
                  : staticAssets.ImgObj.default_edit
              "
              alt
            />
            <span>{{TLang('修改','address')}}</span>
          </a>
          <a
            href="javascript:;"
            class="delete_right"
            :class="{
              active_edit: active_del_flag == parseInt(cIndex + 1)
            }"
            @mouseover="delMouseEnter(cIndex)"
            @mouseleave="delMouseOut(cIndex)"
            @click.prevent.stop="delUserInfo(cIndex)"
          >
            <img
              :src="
                active_del_flag == parseInt(cIndex + 1)
                  ? staticAssets.ImgObj.select_delete
                  : staticAssets.ImgObj.default_delete
              "
              alt
            />
            <span>{{TLang('删除','address')}}</span>
          </a>
        </div>
      </div>
    </div>
    <el-dialog
      :title="!editOrAdd_flag ? TLang('添加观演人','address') : TLang('编辑观演人','address')"
      :visible.sync="dialogFormVisible"
      width="528px"
      class="ticket_view_class"
      @close="getCardClose"
      center
      :close-on-click-modal="false_flag"
    >
      <div slot="title" class="header-title">
        <span class="title-name">
          {{ !editOrAdd_flag ? TLang('添加观演人','address') : TLang('编辑观演人','address') }}
        </span>
        <span class="title-del" @click="getCardClose">
          <img :src="staticAssets.ImgObj.pop_del_icon" alt />
        </span>
      </div>

      <div class="ticket-owner-seat">
        <img :src="staticAssets.ImgObj.add_ticket_owner_icon" alt />
        <span class="ticket-flight">{{ data_source.priceNameTitle }}</span>
        <span>{{TLang('无座','my')}}</span>
      </div>

      <el-form
        :model="cardForm"
        :rules="cardRules"
        ref="cardForm"
        class="ticket_dialog_form"
      >
        <el-form-item
         :class="df_langText?'el_first_itemEn':'el_first_item'"
          :label="TLang('姓名','address')"
          :label-width="formLabelWidth"
          prop="ownerName"
        >
          <el-input
            v-model="cardForm.ownerName"
            autocomplete="off"
            :placeholder="TLang('请输入观演人姓名','address')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="TLang('身份证','address')"
          :label-width="formLabelWidth"
          prop="ownerIdCardNo"
        >
          <el-input
            v-model="cardForm.ownerIdCardNo"
            autocomplete="off"
            :placeholder="TLang('请输入18位身份证号码','address')"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="itemNumber"
          :label="TLang('手机号','address')"
          :label-width="formLabelWidth"
          prop="ownerPhone"
        >
          <el-input
            v-model="cardForm.ownerPhone"
            autocomplete="off"
            :placeholder="TLang('请输入11位手机号码','address')"
            maxlength="11"
            @input="cardForm.ownerPhone = cardForm.ownerPhone.replace(/\D/, '')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn dialog_confirm"
          type="primary"
          style="font-weight:bold!immportant"
          @click="submitCardAdd('cardForm')"
          >{{TLang('确定','address')}}</el-button
        >
        <el-button
          class="dialog_btn dialog_cancel cancel-btn"
          @click="dialogFormVisible = false"
          >{{TLang('取消','address')}}</el-button
        >
      </div>
    </el-dialog>
    <div class="shadow_tips" v-if="userLength_flag">
      {{ `${ReplaceText("X",mul_totalCount,TLang("最多添加X个观演人哦",'address',false,false,null),false)}~` }}
    </div>
  </div>
</template>
<script>
import { getCookie } from "@/utils";
export default {
  name: "TicketViewer",
  data() {
    var user_checked = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(TLang('姓名不能为空','address')));
      } else {
        callback();
      }
    };

    var tel_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('手机号不能为空','address')));
      } else {
        if (!/^1\d{10}$/.test(value)) {
          callback(new Error(TLang('请输入正确的手机号码','address')));
        }
        callback();
      }
    };
    var card_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('身份证号码不能为空','address')));
      } else {
        if (!/^\d{17}[0-9a-zA-Z]{1}$/.test(value)) {
          callback(new Error(TLang('请输入正确的身份证号码','address')));
        }
        callback();
      }
    };
    return {
      data_source: this.table_source,
      cardTableData: this.viewer_source,
      kuaidi_flag: this.kuaidi_type,
      tips_model: this.tips_flag,
      operate_flag: 0, //用户行数判定
      active_edit_flag: 0, //编辑active判定
      active_del_flag: 0, //删除active判定
      editOrAdd_flag: false, //编辑新增判定
      userLength_flag: false, //用户是否超过6
      dialogFormVisible: false, //添加用户信息dialog开关
      operate_edit_index: null, //删除项的index,
      false_flag: false, //遮罩层关闭
      // eslint-disable-next-line no-undef
      formLabelWidth: !this.CheckCN() ? "70px" : "56px",
      cardForm: this.staticAssets.cardForm,
      df_langText: !this.CheckCN() ? true : false,
      ticket_type:
        this.table_source.priceType != 0 ? this.table_source.priceType : 0,
      cardRules: {
        ownerName: [{ validator: user_checked, trigger: "blur" }],
        ownerPhone: [{ validator: tel_checked, trigger: "blur" }],
        ownerIdCardNo: [{ validator: card_checked, trigger: "blur" }]
      },
      mul_ticketId: null,
      mul_ticketCount: null,
      mul_ticketArray: null,
      mul_totalCount: 0,
     };
  },
  props: ["table_source", "viewer_source", "kuaidi_type", "tips_flag"],
  watch: {
    tips_flag(val) {
      console.log(val);
      this.tips_model = val;
    },
    table_source: {
      handler: function(newVal) {
        this.data_source = newVal;
      },
      deep: true,
      immediate: true
    },
    viewer_source: {
      handler: function(newVal) {
        this.cardTableData = newVal;
      },
      deep: true,
      immediate: true
    },
    kuaidi_type(val) {
      this.kuaidi_flag = val;
    }
  },
  components: {},
  beforeCreate() {},
  created() {
    //判断是否是套票
    if (this.data_source.priceType != 0) {
      let mul_ticket_array = {};
      let mul_ticket_id = {};
      let mul_ticket_count = {};
      this.data_source.subPrices.forEach((i, v) => {
        mul_ticket_array[`children${i.id}`] = [];
        mul_ticket_id[`children${i.id}`] = i.id; //储存每个子票的ID
        mul_ticket_count[`children${i.id}`] = i.count; //存储每个子票的个数
        this.mul_totalCount += i.count * this.data_source.quantity[0]; //套票时计算子票总数
      });
      this.mul_ticketArray = mul_ticket_array;
      this.mul_ticketId = mul_ticket_id;
      this.mul_ticketCount = mul_ticket_count;
    } else {
      this.mul_totalCount = this.data_source.quantity[0];
    }
  },
  destroyed() {},
  computed: {},
  methods: {
    //关闭新增用户dialog回调
    getCardClose() {
      //新增编辑重置form表单、确认不重置表单
      // this.getResetDialog("cardForm");
      this.dialogFormVisible = false;
    },
    //添加观演人
    ticketUserAdd() {
      this.editOrAdd_flag = false; //新增状态false
      this.tips_model = false; //tips提示开关
      this.$emit("resetTips", this.tips_model);
      if (this.cardTableData.length >= this.mul_totalCount) {
        this.userLength_flag = true;
        setTimeout(() => {
          this.userLength_flag = false;
        }, 2000);
      } else {
        this.getResetDialog("cardForm"); //重置form表单信息
        this.dialogFormVisible = true; //dialog弹框开关
      }
    },
    //添加观演人的提交
    submitCardAdd(formName) {
      let current_mul_id = null;
      if (this.data_source.priceType != 0 && !this.editOrAdd_flag) {
        let id_sub = this.data_source.subPrices;
        let id_l = this.data_source.subPrices.length;
        for (let i = 0; i < id_l; i++) {
          if (
            this.mul_ticketArray[`children${id_sub[i].id}`].length <
            this.mul_ticketCount[`children${id_sub[i].id}`] *
              this.data_source.quantity[0]
          ) {
            current_mul_id = id_sub[i].id;
            this.mul_ticketArray[`children${id_sub[i].id}`].push(
              current_mul_id
            );
            break;
          }
        }
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let addSource = null;
          let viewer_id = { priceId: this.table_source.priceId };
          if (this.data_source.priceType != 0 && !this.editOrAdd_flag) {
            viewer_id = {
              priceId: this.table_source.priceId,
              subPriceId: current_mul_id
            };
          }
          addSource = Object.assign({}, viewer_id, this.cardForm);
          this.editOrAdd_flag
            ? this.cardTableData.splice(this.operate_edit_index, 1, addSource)
            : this.cardTableData.push(addSource);
          this.publicMethod.getThrowInfo(
            this.editOrAdd_flag ? TLang('编辑成功','address',false,false,null) : TLang('添加成功','address',false,false,null),
            "success"
          );
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });
    },
    //观演人 mouseEnter 事件
    getMouseEnter(tIndex) {
      this.operate_flag = parseInt(tIndex + 1);
    },
    //观演人 mouseOut 事件
    getMouseOut() {
      this.operate_flag = 0;
    },
    //观演人 编辑 mouseEnter 事件
    editMouseEnter(tIndex) {
      this.operate_flag = parseInt(tIndex + 1);
      this.active_edit_flag = parseInt(tIndex + 1);
    },
    //观演人 编辑 mouseOut 事件
    editMouseOut() {
      this.active_edit_flag = 0;
    },
    //编辑观演人信息
    editUserInfo(eIndex) {
      this.editOrAdd_flag = true; //编辑状态true
      this.operate_edit_index = eIndex; //赋值当前编辑下标
      this.getResetDialog("cardForm"); //重置form表单信息
      this.cardForm = Object.assign(
        {},
        this.cardForm,
        this.cardTableData[eIndex]
      );
      this.dialogFormVisible = true; //dialog弹框开关
    },
    //观演人 删除 mouseOver 事件
    delMouseEnter(tIndex) {
      this.operate_flag = parseInt(tIndex + 1);
      this.active_del_flag = parseInt(tIndex + 1);
    },
    //观演人 删除 mouseLeaver 事件
    delMouseOut() {
      this.active_del_flag = 0;
    },
    //删除观演人信息
    delUserInfo(dIndex) {
      this.$emit("delConfirm", dIndex);
    },
    //套票删除时清暂存值
    mulDeleteItem(del_id) {
      this.mul_ticketArray[`children${del_id}`].splice(0, 1);
    },
    //重置dialog表单
    getResetDialog(refName) {
      this.$refs[refName] ? this.$refs[refName].resetFields() : "";
    }
  }
};
</script>

<style scoped lang="less">

.shadow_tips {
  .drama_font_style(inherit, bold, 16px, 64px);
  .drama_specs_unit(240px, 64px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: rgba(255, 255, 255, 1);
}
.ticket-owner-seat {
  border-radius: 22px;
  background: #f7f7f7;
  line-height: 16px;
  padding: 14px 0;
  text-align: center;
  margin: 16px 0;
  font-size: 14px;
  color: #333;
  .ticket-flight {
    margin: 0 12px 0 8px;
  }
  img {
    .drama_specs_unit(16px, 16px);
  }
}
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.ticket_icon span {
  .drama_font_style(inherit, 500, 16px, 21px);
  display: inline-block;
  margin-left: 15px;
  color: rgba(17, 17, 17, 1);
  height: 21px;
}
.ticket_icon i {
  .drama_font_style(normal, 500, 12px, 16px);
  margin-left: 4px;
  color: rgba(102, 102, 102, 1);
}
.ticket_info_user_title {
  display: flex;
  justify-content: space-between;
  .way_title_left {
    display: flex;
    align-items: center;
  }
}
.ticket_info_user_add {
  font-size: 12px;
  height: 24px;
  color: rgba(61, 150, 226, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  &.ticket_info_user_add_disabled {
    background: #f7f7f7;
    color: #ccc;
  }
  img {
    width: 10px;
    height: 10px;
    margin-right: 4px;
  }
}
.ticket_info_user_add {
  width: 60px;
  color: rgba(61, 150, 226, 1);
  background: rgba(236, 245, 253, 1);
}
.dialog_btn {
  .drama_specs_unit(120px, 40px);
  border-radius: 4px;
  font-size: 14px;
}
.ticket_info_user_table {
  margin: 18px 0 8px 32px;
  /deep/ .user_ticket_info .el-form-item {
    margin: 24px 0 0 4px;
  }
  /deep/ .user_ticket_info .el-form-item__label {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  /deep/ .user_ticket_info .el-form-item__content {
    width: 320px;
  }
  /deep/ .user_ticket_info .el-input__inner {
    width: 320px;
    height: 32px;
    border-radius: 0;
    &:focus {
      border-color: #e5e5e5;
    }
  }

  .user_ticket_info {
    .code_verification {
      color: rgba(17, 17, 17, 1);
    }
  }
  .ticket_info_empty {
    font-size: 12px;
    color: rgba(204, 204, 204, 1);
    line-height: 16px;
    margin: 1px 0 24px;
  }

  .ticket_info_user_item {
    .drama_wrap_attr(100%, 50px, 50px, 14px, rgba(17, 17, 17, 1), inherit);
    background: rgba(250, 250, 250, 1);
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info_left {
      align-items: center;
      display: flex;
    }
    .operate_right {
      margin-right: 20px;
      display: flex;
      align-items: center;
      a {
        font-size: 14px;
        display: inline-block;
        span {
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
      .active_edit {
        span {
          color: rgba(61, 150, 226, 1);
        }
      }
      .edit_left {
        margin-right: 30px;
      }
      img {
        width: 16px;
        height: 16px;
        margin: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
        margin-top: 0px;
      }
    }
    span {
      display: inline-block;
    }
    .user_item_no {
      margin-left: 20px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: rgba(204, 204, 204, 1);
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
    }
    .user_itm_name {
      width: 68px;
      margin-left: 28px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .user_item_line {
      width: 1px;
      height: 20px;
      background: rgba(237, 237, 237, 1);
      margin: 0 32px;
    }
    .user_item_line_id {
      width: 1px;
      height: 20px;
      background: rgba(237, 237, 237, 1);
      margin: 0 28px;
    }
    .user_item_card {
      margin-right: 24px;
    }
    .user_item_tel {
      font-weight: bold;
    }
  }
}
.active_background {
  background: #f4f9fe !important;
}
/deep/ .ticket_view_class .el-input__inner {
  border-radius: 0;
  &:focus {
    border-color: #e5e5e5;
  }
}

/deep/ .ticket_view_class input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .ticket_view_class input:-moz-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .ticket_view_class input::-moz-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .ticket_view_class input:-ms-input-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
</style>
<style lang="less">
.qr_code_card {
  height: 32px;
  font-size: 12px;
  padding: 8px 12px;
  padding-top: 7px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px #ececec;
  span {
    display: inline-block;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
  }
}
.qr_code_add {
  height: 32px;
  font-size: 12px;
  padding: 8px 12px;
  padding-top: 7px;
  background: rgba(254, 243, 243, 1);
  box-shadow: 0px 1px 2px 0px rgba(212, 98, 98, 0.2);
  span {
    display: inline-block;
    color: rgba(244, 69, 69, 1) !important;
    line-height: 16px;
  }
  img {
    margin-top: 2px;
    width: 13px;
    height: 13px;
  }
}
/deep/ .qr_code_add .popper__arrow {
  background: rgba(254, 243, 243, 1);
  box-shadow: 0px 1px 2px 0px rgba(212, 98, 98, 0.2);
}
.qr_code_add .popper__arrow::after {
  border-left-color: rgba(254, 243, 243, 1) !important;
}
/deep/ .ticket_view_class .el-input__inner {
  border-radius: 0;
  &:focus {
    border-color: #e5e5e5;
  }
}
</style>
